module.exports = __webpack_public_path__ + "static/media/xz.b927daf3.svg";